import { getHedwigTemplateUrl } from 'omega-rtc/utils/hedwig-template-url';
import type {
  CommsTraceHedwigComponent,
  CommsTraceJourney,
} from './types';

const nonEmpty = (value: string | null | undefined): string | null => {
  const trimmed = value?.trim();
  return trimmed || null;
};

export const getMessageComponent = (
  journey: CommsTraceJourney,
): CommsTraceHedwigComponent | undefined =>
  (journey.stages?.hedwig_delivery?.components || []).find(
    component => Boolean(component.title || component.content),
  );

export const getJourneyChannel = (journey: CommsTraceJourney): string | null => {
  const hedwigDelivery = journey.stages?.hedwig_delivery;
  const messageComponent = getMessageComponent(journey);
  const deliveryComponent = (hedwigDelivery?.components || [])
    .find(component => Boolean(nonEmpty(component.channel)));

  return nonEmpty(messageComponent?.channel)
    || nonEmpty(deliveryComponent?.channel)
    || nonEmpty(hedwigDelivery?.channel)
    || nonEmpty(journey.stages?.relevance_filter?.channel)
    // Legacy responses expose the relevance-filter channel on campaign.
    || nonEmpty(journey.campaign?.channel)
    || null;
};

export const getJourneyTemplateUrl = (journey: CommsTraceJourney): string | undefined => {
  const channel = getJourneyChannel(journey);
  if (!channel) return undefined;

  return getHedwigTemplateUrl(
    journey.template_id,
    channel.toLowerCase().replace(/[\s_-]/g, ''),
  );
};
